import { EMPTY_LIST } from '../../../../constants/common'
import { getItemsIds } from '../../../../utils/common'
import {
  REQUEST_FORM_FIELD_NAME_CHAT_MESSAGE,
  REQUEST_FORM_FIELD_NAME_IS_CHATROOM_PUBLIC,
  REQUEST_FORM_INITIAL_VALUES,
} from '../../../Request'

export function getChatroomMessageCreateRequestInitialValues({
  isChatroomPublic,
  message,
}) {
  return {
    ...REQUEST_FORM_INITIAL_VALUES,
    [REQUEST_FORM_FIELD_NAME_CHAT_MESSAGE]: message?.uuid || null,
    [REQUEST_FORM_FIELD_NAME_IS_CHATROOM_PUBLIC]: isChatroomPublic,
  }
}

export function getChatroomMessageCreateRequestAttachPayload({
  isChatroomPublic,
  message,
  requestId,
}) {
  return {
    [REQUEST_FORM_FIELD_NAME_CHAT_MESSAGE]: message?.uuid,
    [REQUEST_FORM_FIELD_NAME_IS_CHATROOM_PUBLIC]: isChatroomPublic,
    requestId,
  }
}

export function getChatroomMessageAttachRequestExcludeIds(message) {
  return getItemsIds(message?.linked_requests || EMPTY_LIST)
}
